import React from "react";
import  AppHeader  from "./AppHeader";
import  AppSidebar from "./AppSidebar";
import  App from "./App";
import  AppFooter from "./AppFooter";
import  AppLogin from "./AppLogin";

// Simple CSS Grid layout; adapt classNames to your setup (Tailwind, CSS modules, etc.)
export const AppLayout: React.FC = () => {
  return (
    <div className="app">
    <div id="rootLogin">
        <AppLogin />
    </div>
        <div className="page-wrapper compact-wrapper modern-sidebar" id="pageWrapper">
            <div id="header">
                <AppHeader />
            </div>
            <div className="page-body-wrapper horizontal-menu" id="horizontalMenu">
                <div id="sidebar">
                    <AppSidebar />
                </div>
                <div className="page-body">
                    <div className="container-fluid g-xs-1 g-md-0">
                        <div id="root">
                            <App />
                        </div>
                    </div>
                </div>
                <div id="footer">
                    <AppFooter />
                </div>
            </div>
        </div>
    </div>
  );
};
